/* eslint-disable import/no-extraneous-dependencies,import/no-unresolved,import/extensions */
import config from 'config';
/* eslint-enable import/no-extraneous-dependencies,import/no-unresolved,import/extensions */

export default config;



// WEBPACK FOOTER //
// ./src/config.js